module.exports = __webpack_public_path__ + "img/camping.4480dede.svg";